<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    class="w-4 h-4"
  >
    <rect x="2" y="2" width="4.67" height="4.67" rx="1" :fill="active ? 'url(#dash_blue_a)' : 'url(#dash_gray_a)'" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.67 8.84C6.5 8.84 7.17 9.51 7.17 10.34V13C7.17 13.83 6.5 14.5 5.67 14.5H3C2.17 14.5 1.5 13.83 1.5 13V10.34C1.5 9.51 2.17 8.84 3 8.84H5.67ZM3 9.84C2.72 9.84 2.5 10.06 2.5 10.34V13C2.5 13.28 2.72 13.5 3 13.5H5.67C5.95 13.5 6.17 13.28 6.17 13V10.34C6.17 10.06 5.95 9.84 5.67 9.84H3Z"
      :fill="active ? 'url(#dash_blue_b)' : 'url(#dash_gray_b)'"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13 1.5C13.83 1.5 14.5 2.17 14.5 3V5.67C14.5 6.5 13.83 7.17 13 7.17H10.34C9.51 7.17 8.84 6.5 8.84 5.67V3C8.84 2.17 9.51 1.5 10.34 1.5H13ZM10.34 2.5C10.06 2.5 9.84 2.72 9.84 3V5.67C9.84 5.95 10.06 6.17 10.34 6.17H13C13.28 6.17 13.5 5.95 13.5 5.67V3C13.5 2.72 13.28 2.5 13 2.5H10.34Z"
      :fill="active ? 'url(#dash_blue_b)' : 'url(#dash_gray_b)'"
    />
    <rect x="9.34" y="9.34" width="4.67" height="4.67" rx="1" :fill="active ? 'url(#dash_blue_c)' : 'url(#dash_gray_c)'" />
    <defs>
      <!-- Blue gradient defs -->
      <linearGradient id="dash_blue_a" x1="2.21" y1="6.09" x2="6.67" y2="3.42" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <linearGradient id="dash_blue_b" x1="2.09" y1="12.88" x2="14.5" y2="5.45" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <linearGradient id="dash_blue_c" x1="9.55" y1="13.42" x2="14" y2="10.75" gradientUnits="userSpaceOnUse">
        <stop stop-color="#C7CBFF" />
        <stop offset="1" stop-color="#0012FA" />
      </linearGradient>
      <!-- Gray gradient defs -->
      <linearGradient id="dash_gray_a" x1="2.21" y1="6.09" x2="6.67" y2="3.42" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
      <linearGradient id="dash_gray_b" x1="2.09" y1="12.88" x2="14.5" y2="5.45" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
      <linearGradient id="dash_gray_c" x1="9.55" y1="13.42" x2="14" y2="10.75" gradientUnits="userSpaceOnUse">
        <stop stop-color="#D3D5E4" />
        <stop offset="1" stop-color="#585B79" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script setup lang="ts">
defineProps<{
  active?: boolean
}>()
</script>
